import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function OurServices() {
  const services = [{
    title: 'Commercial Cleaning',
    description: 'A neat, tidy office is the hallmark of a professional business, allowing employees to focus on their work. A poorly maintained office can lead to decreased productivity and a negative impression on clients.',
    buttonText: 'Request a Quote',
    href: '/book/commercial',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Basic Home Cleaning',
    description: 'The service is flexible and affordable. It is designed to meet your daily needs and facilitate your life on a regular basis. We handle the dusting, vacuuming, mopping, and general tidying.',
    buttonText: 'Book Online',
    href: '/book/home-cleaning',
    image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Spring / Deep Cleaning',
    description: 'Spring comes but once a year, but we recommend two Spring (a.k.a. Deep) Cleanings annually. Building on our Basic Home cleaning, we get into the nooks and crannies that are often missed.',
    buttonText: 'Book Online',
    href: '/book/deep-cleaning',
    image: 'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Move-In / Move-Out',
    description: "Moving is an incredibly busy and stressful time, so we'd like to take one thing off your mind by cleaning your old or new home top to bottom, ensuring it is spotless and ready.",
    buttonText: 'Book Online',
    href: '/book/move-in-out',
    image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Post Renovation',
    description: 'So your latest building or renovation project is finally coming to an end. All you want to do is get rid of the dust and debris. We provide specialized post-construction cleaning.',
    buttonText: 'Book Online',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }, {
    title: 'Airbnb / Short Term Rental',
    description: 'We offer a comprehensive Airbnb cleaning solution for your Airbnb business. Need a scheduled maid to clean up your condo, apartment or home? Book our reliable turnover service.',
    buttonText: 'Book Online',
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  return <main className="min-h-screen" data-id="element-1292">
      {/* Dark Page Hero — matches homepage premium feel */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-1293">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-1294"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-1295">
          {/* Breadcrumb */}
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-1296">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-1297">
              Home
            </Link>
            <span className="mx-2" data-id="element-1298">/</span>
            <span className="text-accent" data-id="element-1299">Our Services</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1300">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-1301">
              Our Services
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-1302">
              Residential & Commercial Services
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-light py-20 md:py-28" data-id="element-1303">
        <div className="container mx-auto px-6 md:px-12" data-id="element-1304">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10" data-id="element-1305">
            {services.map((service, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1306">
                <div className="h-64 overflow-hidden relative group" data-id="element-1307">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-1308" />
                  <div className="absolute inset-0 bg-primary/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-1309"></div>
                </div>

                <div className="p-8 flex flex-col flex-grow" data-id="element-1310">
                  <h3 className="text-2xl font-heading font-bold text-primary uppercase tracking-wide mb-4" data-id="element-1311">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-8 flex-grow" data-id="element-1312">
                    {service.description}
                  </p>

                  <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-100" data-id="element-1313">
                    {service.href ? <Link to={service.href} className="bg-accent hover:bg-accent/90 text-white px-6 py-2.5 rounded-full text-sm font-bold uppercase tracking-wider transition-all transform hover:scale-105 inline-block text-center" data-id="element-1314">
                        {service.buttonText}
                      </Link> : <button className="bg-accent hover:bg-accent/90 text-white px-6 py-2.5 rounded-full text-sm font-bold uppercase tracking-wider transition-all transform hover:scale-105" data-id="element-1315">
                        {service.buttonText}
                      </button>}
                    <a href="#" className="text-sm font-bold text-primary uppercase tracking-widest hover:text-accent transition-colors" data-id="element-1316">
                      Learn More
                    </a>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
}